import { Theme, css } from '@emotion/react';
import CardBase from 'omakase/ProductCard/CardBase';

export interface PlatterCardProps {
  title: string;
  itemId: number;
  imgSrc: string;
  imgAltLabel: string;
  linkTo: string;
  onClick?: () => void;
}

const PlatterCard: React.FunctionComponent<PlatterCardProps> = ({
  title,
  imgSrc,
  imgAltLabel,
  ...rest
}) => (
  <CardBase
    overline={title}
    imageComponent={
      <div
        css={(theme: Theme) => css`
          ${theme.utils.aspectRatio(4, 5, 'cover')}
        `}
      >
        <img src={imgSrc} alt={imgAltLabel} />
      </div>
    }
    size={'medium'}
    {...rest}
  />
);

export default PlatterCard;
